/**
 * Textos de caja. Voz de mostrador: vos, oración corta, mismo wording en PC y celular.
 * «Contado» = conteo físico; no confundir con venta «al contado».
 */
import { formatMoney } from './cashFormatMoney';

export const cashArqueoCopy = {
  theoreticalBalance: 'Debería haber',
  theoreticalHintNegative: 'Egresos > efectivo',
  countedCash: 'Contado',
  difference: 'Diferencia',
  countedInputA11y: 'Efectivo contado al cierre',
  countedFieldLabel: 'Contado',
  missingCountedTitle: 'Falta el contado',
  missingCountedMessage: 'Ingresá cuánto hay en caja antes de cerrar.',
  zeroCountedConfirm: '¿Cerrar con $0 contado?',
  differenceNoteLabel: 'Motivo',
  differenceNotePlaceholder: 'Ej. error de cambio',
  notesOptionalLabel: 'Nota',
  notesOptionalPlaceholder: 'Opcional',
  missingDifferenceNoteTitle: 'Falta el motivo',
  missingDifferenceNoteMessage: 'Indicá por qué hay diferencia antes de cerrar.',
  shortageCloseTitle: 'Faltante en caja',
  surplusCloseTitle: 'Sobrante en caja',
  differenceConfirmCta: 'Cerrar con diferencia',
  openConfirmTitle: 'Abrir caja',
  openConfirmLabel: 'Abrir turno',
  closeTurnoCta: 'Contar y cerrar',
  closeTurnoModalTitle: 'Cerrar caja',
  closeConfirmCta: 'Cerrar caja',
  historyTitle: 'Historial de cierres',
  noDifference: 'Cuadra',
  openingSuggestedHint: 'Del último cierre · 0 si abrís sin efectivo',
  registerOutflowCta: 'Registrar egreso',
  registerInflowCta: 'Registrar ingreso',
  statusOpen: 'Abierta',
  statusClosed: 'Cerrada',
  resumenTitle: 'Resumen del turno',
  closeTurnoCashSectionTitle: 'Efectivo en caja',
  closeTurnoNonCashSectionTitle: 'No va al arqueo',
  closeTurnoOpeningRowLabel: 'Apertura',
  closeTurnoCashSalesRowLabel: '+ Cobros en efectivo',
  closeTurnoInflowsRowLabel: '+ Ingresos del turno',
  closeTurnoOutflowsRowLabel: '− Egresos del turno',
  sessionSalesCountLabel: 'Ventas del turno',
  sessionSalesAmountLabel: 'Monto del turno',
  closedCashExpensesHint:
    'Caja cerrada. Registrá gastos en Gastos. Pagalos al abrir el turno o con transferencia.',
} as const;

export function formatCashDifferenceConfirmMessage(difference: number): string {
  const amount = formatMoney(Math.abs(difference));
  if (difference > 0) {
    return `Sobrante de ${amount}. ¿Cerrar la caja?`;
  }
  return `Faltante de ${amount}. ¿Cerrar la caja?`;
}

export function formatOpeningConfirmMessage(amount: number): string {
  return `Abrir turno con fondo de ${formatMoney(amount)}.`;
}

export function formatOpenTurnoLastCloseInfo(closingAmount: number): string {
  return `El último cierre quedó en ${formatMoney(closingAmount)}. Usalo como fondo o cargá otro monto.`;
}

export function cashNonCashTodayLabel(customerModuleEnabled: boolean): string {
  return customerModuleEnabled ? 'Digital y fiado hoy' : 'Medios digitales hoy';
}
